module.exports = __webpack_public_path__ + "img/service-07.547cb4d1.png";